
import React, { useState, useEffect} from 'react';
import { NavLink, useParams  } from 'react-router-dom';
import DatosCabezaFamilia from './../DatosCabezaFamilia.jsx';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import { useNavigate } from "react-router-dom";

export default function RegistrarCarpeta(){
    const { token, rol } = useAuth();
    const { idCabezaFamilia } = useParams();
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [Cargando, setCargando] = useState(false);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const {register, handleSubmit, control, setValue, reset, watch, getValues, formState: { errors }} = useForm();
    useEffect(() => {
        let now = new Date();
        setValue('cabIdcabezafamilia', idCabezaFamilia);
        setValue('usrId', rol);
        const fetchData = async () => {
            let url = '/archivo/crearformularioregistrocarpeta';
            let obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
            
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
    }, []);
    const onSubmit = async (data) => {
        setCargando(true);
        let url = '/archivo/registrarcarpeta';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Registrar carpeta', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar carpeta', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar carpeta', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            navigate('/archivo/'+data.cabIdcabezafamilia);
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Registrar carpeta</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/archivo/0`} >Archivo</NavLink></li>}
                        <li className="breadcrumb-item active"> Registrar carpeta</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos}></DatosCabezaFamilia>
                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                        <div className="card card-info">
                            <div className="card-body">
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>                                
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-info">Registrar carpeta</button>
                            </div>
                        </div>
                    </form>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" effect="solid" className="custom-tooltip" place="bottom"/>
            </section>
        </div>
    );
}